import React, { useEffect, useState } from "react"

/* Hallmark · component: widget flotante de ordering (estilo Los Potrillos)
 * Botón flotante que abre un panel con las opciones de pedido:
 * Pickup Order (Toast, directo y destacado) + Uber Eats + DoorDash.
 * Estilos en src/index.css (.order-widget / .order-launcher / .order-panel).
 * Recibe props desde footer.php vía data-props (JSON). */

const BagIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007Z" />
  </svg>
)

const CloseIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
  </svg>
)

const ArrowIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true" className="w-4 h-4">
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
  </svg>
)

const SCROLL_THRESHOLD = 300 // px de scroll antes de aparecer

function FloatingActions({
  toastUrl = "https://order.toasttab.com/online/bistro-brunch-5950-w-mcdowell-rd-suite-101",
  uberEatsUrl = "https://www.ubereats.com/store/bistro-brunch-cocina-mexicana-5950-w-mcdowell-rd-101/0mTnkiCTTUeX0bQ_uThbfg",
  doorDashUrl = "https://www.doordash.com/store/bistro-brunch-phoenix-37944433/86150146/",
  brandLogo = "",
}) {
  const [open, setOpen] = useState(false)
  const [visible, setVisible] = useState(false)   // aparece al hacer scroll down
  const [dismissed, setDismissed] = useState(false) // el usuario lo cerró con la X

  useEffect(() => {
    const onKey = e => {
      if (e.key === "Escape") setOpen(false)
    }
    document.addEventListener("keydown", onKey)
    return () => document.removeEventListener("keydown", onKey)
  }, [])

  useEffect(() => {
    let ticking = false
    const onScroll = () => {
      if (ticking) return
      ticking = true
      window.requestAnimationFrame(() => {
        setVisible(window.scrollY > SCROLL_THRESHOLD)
        ticking = false
      })
    }
    window.addEventListener("scroll", onScroll, { passive: true })
    onScroll()
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  if (dismissed) return null

  const shown = visible

  return (
    <div className={`order-widget${open ? " is-open" : ""}${shown ? " is-visible" : ""}`}
         aria-hidden={!shown}>

      {/* Botón de descarte: solo visible con el panel abierto */}
      {open && (
        <button type="button"
                className="order-dismiss focus-visible:outline-2 focus-visible:outline-acento focus-visible:outline-offset-2"
                aria-label="Dismiss ordering widget"
                onClick={() => {
                  setOpen(false)
                  setDismissed(true)
                }}>
          <CloseIcon />
        </button>
      )}

      {/* Panel de opciones */}
      <div className="order-panel" role="menu" aria-label="Ordering options" aria-hidden={!open}>
        <p className="order-panel-title">Order from Bistro Brunch</p>

        <a href={toastUrl} target="_blank" rel="noopener noreferrer" role="menuitem"
           tabIndex={open && shown ? 0 : -1}
           className="order-option order-option-pickup focus-visible:outline-2 focus-visible:outline-acento-oscuro focus-visible:outline-offset-2">
          <span>
            <span className="order-option-name">Pickup Order</span>
            <span className="order-option-note">Direct, no third-party fees</span>
          </span>
          <ArrowIcon />
        </a>

        <a href={uberEatsUrl} target="_blank" rel="noopener noreferrer" role="menuitem"
           tabIndex={open && shown ? 0 : -1}
           className="order-option order-option-uber focus-visible:outline-2 focus-visible:outline-acento focus-visible:outline-offset-2">
          <span>
            <span className="order-option-name">Uber Eats</span>
            <span className="order-option-note">Delivery</span>
          </span>
          <ArrowIcon />
        </a>

        <a href={doorDashUrl} target="_blank" rel="noopener noreferrer" role="menuitem"
           tabIndex={open && shown ? 0 : -1}
           className="order-option order-option-doordash focus-visible:outline-2 focus-visible:outline-acento focus-visible:outline-offset-2">
          <span>
            <span className="order-option-name">DoorDash</span>
            <span className="order-option-note">Delivery</span>
          </span>
          <ArrowIcon />
        </a>
      </div>

      {/* Botón lanzador */}
      <button type="button"
              className="order-launcher focus-visible:outline-2 focus-visible:outline-acento-oscuro focus-visible:outline-offset-2"
              aria-expanded={open}
              tabIndex={shown ? 0 : -1}
              aria-label={open ? "Close ordering options" : "Open ordering options"}
              onClick={() => setOpen(o => !o)}>
        {brandLogo
          ? <span className="order-launcher-logo"><img src={brandLogo} alt="" /></span>
          : (open ? <CloseIcon /> : <BagIcon />)}
        <span>{open ? "Close" : "Pickup Order"}</span>
        {brandLogo ? (open ? <CloseIcon /> : <BagIcon />) : null}
      </button>
    </div>
  )
}

export default FloatingActions